/**
 * @description Bridge to connect React ResendEmailModal component to AngularJS
 * Allows the React component to be used in AngularJS templates
 */
import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import ResendEmailModal from './ResendEmailModal';

const ResendEmailModalBridge = react2angular(ResendEmailModal, [
  'stepId',
  'flowId',
  'nodeCustomMail',
  'onClose'
]);

export default ResendEmailModalBridge;
